import React from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import extractDialogProps from 'components/extractDialogProps';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';

import { useSnackbar } from 'notistack';
import { makeStyles } from '@material-ui/core/styles';

import useClient from 'components/Auth/useClient';

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width:'100%'
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
  dialogContent: {
    width: '100%'
  },
  actions: {
    width: '100%',
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function RecreateDialog(props) {
  const [dialogProps] = extractDialogProps(props);
  const classes = useStyles();

  const {
      id,
      contentId,
      handleRemoveDownloadButton,
      handleClose,
  } = props;

  const { enqueueSnackbar } = useSnackbar();
  const client = useClient();
  const handleSend = React.useCallback(() => {
    client.post('api/document/recreate/' + id + '/' + contentId)
      .then(() => {
        handleRemoveDownloadButton();
        handleClose();
        enqueueSnackbar('再作成を受け付けました。時間を置いてページを更新してください。', {  style: { whiteSpace: 'pre-line' } });
      })
      .catch(() => {
        enqueueSnackbar('再作成の受付に失敗しました。時間を置いて再度実行してください。', {  variant: 'error' });
      });
  }, [client, id, contentId]);


  return (
    <div>
      <Dialog
        {...dialogProps}
        aria-labelledby="register-dialog-title"
        aria-describedby="register-dialog-description"
        fullWidth="true"
        className={classes.dialog}
      >
        <Container className={classes.container}>
        <DialogTitle id="recreate-dialog-title">PDFの再作成</DialogTitle>
        <DialogContent dividers="true" className={classes.dialogContent}>
          <Typography>
            PDFを再作成します。
          </Typography>
          <Typography>
            正常にPDFが作成されていない場合に使用して下さい。
          </Typography>
        </DialogContent>
        <DialogActions className={classes.actions}>
          <Button
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              onClick={handleSend}>
              再作成する
            </Button>
          </DialogActions>
        </Container>
      </Dialog>
    </div>
  );
}